import { badgeApolloClient } from "@/utils/graphql-client-badges";
import {
  Mutation_CloseCashPoint,
  Mutation_CompleteTransaction,
  Mutation_StartTransaction,
} from "./queries-badges/fiskaly.graphql";
import {
  MutationCloseCashPointArgs,
  MutationCompleteTransactionArgs,
  MutationStartTransactionArgs,
  Mutation_CloseCashPointMutation,
  Mutation_CloseCashPointMutationVariables,
  Mutation_CompleteTransactionMutation,
  Mutation_CompleteTransactionMutationVariables,
  Mutation_StartTransactionMutation,
  Mutation_StartTransactionMutationVariables,
} from "@/types/gql/generated/graphql-badges";

export async function startTransactionMutation(
  payload: MutationStartTransactionArgs
) {
  const resp = await badgeApolloClient.mutate<
    Mutation_StartTransactionMutation,
    Mutation_StartTransactionMutationVariables
  >({
    mutation: Mutation_StartTransaction,
    variables: {
      seqId: payload.seqId,
      transactionUUID: payload.transactionUUID,
      cashfloatUid: payload.cashfloatUid,
      cashfloatSeqId: payload.cashfloatSeqId,
      bookingUUID: payload.bookingUUID,
      posRegisterId: payload.posRegisterId,
      groupId: payload.groupId,
      error: payload.error,
    },
  });
  return resp.data?.startTransaction;
}

export async function completeTransactionMutation(
  payload: MutationCompleteTransactionArgs
) {
  const resp = await badgeApolloClient.mutate<
    Mutation_CompleteTransactionMutation,
    Mutation_CompleteTransactionMutationVariables
  >({
    mutation: Mutation_CompleteTransaction,
    variables: {
      seqId: payload.seqId,
      transactionUUID: payload.transactionUUID,
      cashfloatSeqId: payload.cashfloatSeqId,
      bookingUUID: payload.bookingUUID,
      posRegisterId: payload.posRegisterId,
      groupId: payload.groupId,
      receiptNumber: payload.receiptNumber,
      payments: payload.payments,
      items: payload.items,
      error: payload.error,
      completedAt: payload.completedAt,
    },
  });
  return resp.data?.completeTransaction;
}

export async function closeCashPointMutation(
  payload: MutationCloseCashPointArgs
) {
  const resp = await badgeApolloClient.mutate<
    Mutation_CloseCashPointMutation,
    Mutation_CloseCashPointMutationVariables
  >({
    mutation: Mutation_CloseCashPoint,
    variables: {
      closureUuid: payload.closureUuid,
      posRegisterId: payload.posRegisterId,
      cashfloatUid: payload.cashfloatUid,
      seqId: payload.seqId,
      groupId: payload.groupId,
      closedAt: payload.closedAt,
    },
  });
  return resp.data?.closeCashPoint;
}
